import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M28.694 3.306 3.308 28.692C1.39 26.63.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263a8.14 8.14 0 0 1 3.004 2.043",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M9.996 19.83c-.036.358-.64 1.086-1.185 1.126s-.74.774-1.209.57c.439-.093.439-.65.782-.821-.248-.1-.379.53-.699.53s-.474.568-.865.529c-.39-.04-.432.693-1.214.701-.599.007-1.34.788-1.606.45.58-.092.815-.452 1.161-.847.557-.635 1.185-.35 1.399-.913a1.35 1.35 0 0 1-.842.278c-.364-.009-.764.648-1.173.357.237-.033.391-.145.64-.437.255-.298.629-.105.924-.41.462-.477.86-.08 1.304-.675-.125-.067-.391-.02-.64.125-.249.146-.569-.099-.853.073.035-.39.699-.167 1.113-.437.469-.304.857-.215 1.227-.178-.516-.004-.717-.55-1.428-.391-.31.07-.557-.476-.865-.198.009-.206.332-.371.664-.173.331.199.465-.173 1.125.292.273.192.74-.12 1.037.086-.038-.126-.207-.205-.406-.189.125-.284.928-.248 1.277.037.166.052.367.158.332.516M15 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2c-.552 0 0 0 0 0",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M12.85 19.297c.125.233.64.18.728.16.074.279.311.272.413.426.103.153.45.14.553.053-.093-.013-.214-.093-.33-.233-.14-.17.678-1.567.785-1.387-.099-.876-1.036-.373-1.12-.287 0-.473.526-.766.6-.74-.12-.226-.395-.22-.6-.2-.21.018-.542.387-.375.967-.072-.003-.905.327-1.005.327zM25 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2c-.552 0 0 0 0 0",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M19.651 14.164c.25-.224 1.248-.561 1.509-.393s1.127.37 1.554.09.63-.427.819-.393a.68.68 0 0 0 .528.314c.035.036 1.38-.153 1.18-.718-.084-.236-1.28-.27-1.358-.275a.5.5 0 0 0-.03-.18.77.77 0 0 1-.106-.498 2 2 0 0 0-.333.493c-.225-.146-.783.068-1.044.124-.26.056-1.139-.079-1.34-.28-.202-.203-.594-.326-.962-.427-.506-.139-1.68-.573-1.612 0 .088.735.856 1.868.856 1.868zM13 24a1 1 0 1 0 0-2 1 1 0 0 0 0 2c-.552 0 0 0 0 0",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M19.769 13.507c.36.78.316 2.01-.248 2.792-.09.123-.662.616-.393.981.313.426 1.487.727 1.566.816.079-.165 1.308-1.328 1.962-.816-.452.057-.902.369-.98.71.129-.065 1.358 0 1.262.816-.045-.26-1.184-.71-1.64 0s.176 1.5.456 1.597c-.248.083-1.586-.58-1.162-1.514-.12.038-1.586-.223-2.329-.9-.643-.585-.585-1.59-.57-1.667-.54-.047-.952.18-2.507-.322-2.346-.757-2.92.777-2.402 1.89.336.719-.081 2.305.244 3.116.52.236 1.298.575 1.293.71a.86.86 0 0 1-.068.887.9.9 0 0 0-.102-.527c-.103-.163-.648-.354-.743-.39.095.045.27 1.197-.18 1.564-.037-.54-.5-1.01-.604-1.174-.485 0-.878.412-.878.92-.022-.189-.25-.375-.222-.535-.135-.438.056-.846.609-.928-.068-.166.17-.338.079-.527-.115-.241-.327-.556-.643-.922.192-.343.135-.805.023-1.089-.162-.407-.316-.307-.891.355-.938 1.08-2.189.78-3.294 1.49-.294.19-.586.26-.27-.07.315-.332 1.15-.663 1.691-.947 1.014-.531 1.873-1.42 2.21-3.146.796-4.058 3.723-2.72 5.573-1.963 1.736.71 1.42-.9.541-1.87-1.057-1.165-.746-2.997 1.484-2.651.89-.13 1.477.398 1.133.712-.068.07-.458 1.612 0 2.602",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M23 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2c-.552 0 0 0 0 0M16 9.27c.028-.074.908-.339 2.075-.126.378.07.842.013 1.245.261-.258-.884-1.091-.437-3.32-1.546.76.22 1.568.399 2.39.6.645.159 1.335.3 1.771.696.185.168.75.003.795-.01.274-.085.462-.06.611.01.35-.254.762-.183 1.06.115a.24.24 0 0 1 .14-.12c.275-.082.497.172.573.502.214-.043.458.072.62.23.222-.124.375-.13.432-.002.198-.101.456-.165.584.178.129.342-.303.24-.374.963-.043.446-.502.622-.865.356-.58-.427-1.145-.495-1.425.152-.281.647-.5 1.022-1.181.812-.245-.077-.561.025-.76.317-.198.291-1.765-.024-3.015-.102-.608-.038-.994.05-1.356.444.631-1.42 1.49-.64 1.905-1.09.246-.267.433-.47.561-.724a.28.28 0 0 1 .183-.16c-.732-.25-.66-1.56-3.072-.968.235-.452 1.135-.454 2.037-.28.4.078.836.072 1.154.28-.302-1.153-2.803-.693-2.768-.788",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagBtn = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagBtn_default = SvgFlagBtn;

export { FlagBtn_default as default };
